import * as types from '../constants/actionTypes';
const initialState = {
	usersList: [],
	userRoles: [],
	userDetails: {},
	bloodGroupList: [],
	passwordData: 0,
	userNotifications:[]
};

export default function timer(state = [], action) {
	switch (action.type) {
		case types.GET_USERS:
			return Object.assign({}, state, { usersList: action.usersList });

		case types.GET_USER_DETAILS:
			return Object.assign({}, state, { userDetails: action.userDetails });

		case types.GET_ROLES:
			return Object.assign({}, state, { userRoles: action.userRoles });

		case types.GET_BLOOD_GROUP_LIST:
			return Object.assign({}, state, { bloodGroupList: action.bloodGroupList });

		case types.GET_USER_DETAILS_ON_UPDATE:
			return Object.assign({}, state, { userDetails: action.userDetails });

		case types.VERIFY_PASSWORD:
		console.log("inside reducer",action.passwordData)
			return Object.assign({}, state, { passwordData: action.passwordData });

		case types.GET_USER_NOTIFICATIONS:
			return Object.assign({}, state, { ...state, userNotifications: action.userNotifications });	
		case types.CLEAR_ALL_NOTIFICATIONS:
			return Object.assign({}, state, { clearNotifications: action.userNotifications });	


		// case types.GET_PATIENT_IMAGE:
		// 	return Object.assign({}, state, { latestPatientImage: action.latestPatientImage });

		default:
			return initialState;
	}
}

